import { z } from 'zod';

export const EmptyContext = z.object({ type: z.literal('empty') });
export type EmptyContext = z.infer<typeof EmptyContext>;
